import { Component, OnInit, HostListener, TemplateRef } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { SummaryService } from '../services/summary.service';
import { TokenManager } from '../Globals';
import { Globals } from '../objects/Globals';
import {Location, LocationStrategy, PathLocationStrategy} from '@angular/common';

import { BsModalService } from 'ngx-bootstrap/modal';
import { BsModalRef } from 'ngx-bootstrap/modal/bs-modal-ref.service';

@Component({
  selector: 'app-layout-catalogue',
  templateUrl: './layout-catalogue.component.html',
  providers: [Location, {provide: LocationStrategy, useClass: PathLocationStrategy}],
  styleUrls: ['./layout-catalogue.component.css']
})
export class LayoutCatalogueComponent implements OnInit {
  private cartType:string;
  private cartId:string;
  private catalogueType:string;
  private catalogueSummary:string;
  private catalogueComponentId:string;
  private selectedProductDetailId:string;
  private forceRefreshDetail:boolean = true;
  private noOfItems : string;
  cartComponentId:string;
  smallPad: boolean = false;
  location: Location;
  searchKeyword: string = '';
  summaryName: string;
  isProductDetail:boolean = false;
  modalRef: BsModalRef;

  constructor(private route:ActivatedRoute, 
    private globals:Globals, 
    location: Location,
    private router:Router, 
    private summaryService:SummaryService,
    private tokenManager:TokenManager,
    private modalService: BsModalService) {
      this.location = location;
     }

  onCartSet(cartComponentId:string){
    this.cartComponentId = cartComponentId;

    // this.summaryService.createSummaryWithParent(this.catalogueType, this.catalogueSummary, this.cartComponentId).subscribe(result=>{
    //   this.catalogueComponentId = result;
      
    // });
  }

  @HostListener('window:resize', ['$event'])
  onResize(event) {
    if (event.target.innerWidth < 992) {
      this.smallPad = true;
    }
    else{
      this.smallPad = false;
    }
  }

  toggleSidebar(showView : boolean) {
    if (showView) {
      this.smallPad = false;
    }
    else {
      this.smallPad = true;
    }
  }

  onSearchKeywordChange(keyword:string){
    this.searchKeyword = keyword;
  }

  updateCards(event){
    this.forceRefreshDetail = !this.forceRefreshDetail;
  }

  updateTotalRows(event){
    this.noOfItems = event;
  }

  showCart(template: TemplateRef<any>){
      this.modalRef = this.modalService.show(template, {class: 'modal-dialog-centered modal-cart', ignoreBackdropClick: true});
  }

  setSummaryName($event){
    this.summaryName  = $event;
  }

  onDecline(): void {
    this.modalRef.hide();
  }

  ngOnInit() {
    this.smallPad = (window.innerWidth) < 992;
    this.tokenManager.store("BRNCurrentRoute", this.router.url);
    if(this.globals.Session == null){this.router.navigate(['/', '/']) };

    this.cartComponentId = this.route.snapshot.paramMap.get('cartId');
    this.catalogueComponentId = this.route.snapshot.paramMap.get('summaryId');

    if(this.catalogueComponentId && this.globals.Session){
      this.summaryService.getCurrentSearchKeyword(this.catalogueComponentId).subscribe(result=>{
        if(result){
          this.searchKeyword = result;
        }else{
          this.searchKeyword = "";
        }
      })
    }
  }

  onSelectedItem(selectedId:string) {
    this.isProductDetail = true;
    this.selectedProductDetailId = selectedId;
  }

}
